module.exports = __webpack_public_path__ + "static/media/commute.26c2dcce.svg";